import { render, staticRenderFns } from "./TeamCarousel.vue?vue&type=template&id=1134e24c&scoped=true&"
import script from "./TeamCarousel.vue?vue&type=script&lang=js&"
export * from "./TeamCarousel.vue?vue&type=script&lang=js&"
import style0 from "./TeamCarousel.vue?vue&type=style&index=0&id=1134e24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134e24c",
  null
  
)

export default component.exports